export const courseList = [
  { label: "FLUTTER", route: "/flutter", trending: true },
  { label: "AI / GEN AI", route: "/ai_gen_ai", trending: true },
  { label: "PLAYWRIGHT AUTOMATION TESTING", route: "/playwright_testing", trending: true },
  {
    label: "JAVA SELENIUM AUTOMATION TESTING",
    route: "/software_testing",
  },
  { label: "REACT", route: "/react" },
  { label: "REACT NATIVE", route: "/react_native", trending: true },
  { label: "PYTHON", route: "/apm" },
  { label: "C & C++ PROGRAMMING", route: "/c_cpp" },
  { label: "DATA ANALYTICS", route: "/data_analytics", trending: true },
  { label: "Full Stack", route: "/fullstack", trending: true },
  { label: "DIGITAL MARKETING", route: "/digital_marketing" },
  { label: "JAVA & SPRING BOOT", route: "/java" },
  { label: "ANDROID", route: "/android" },
  { label: "iOS Mobile Application Development", route: "/ios" },
  { label: "PHP", route: "/php" },
];
